/**
 * PhotoSwipe Zoom Overlay Custom JavaScript
 * Enhances the product image zoom overlay with:
 * - Zoom slider control (0.5x - 1.5x, default 1x = original size)
 * - Thumbnail navigation (bottom left)
 * - Close button (top right)
 * Note: Original image size on open, slider centered at 1x
 */

(function() {
  'use strict';

  const LuxoticZoomOverlay = {
    pswpInstance: null,
    currentZoom: 1,
    minZoom: 0.5,
    maxZoom: 1.5,
    currentIndex: 0,
    zoomControls: null,
    thumbnailContainer: null,
    zoomMonitorInterval: null,

    init: function() {
      if (this.isInitialized) return;

      this.currentZoom = 3;
      this.setupMutationObserver();
      this.setupClickListener();

      this.isInitialized = true;
      console.log('LuxoticZoomOverlay: Initialized with auto-zoom 3x');
    },

    setupClickListener: function() {
      document.body.addEventListener('click', (e) => {
        const zoomBtn = e.target.closest('.product-gallery__zoom-button');
        if (zoomBtn) {
          setTimeout(() => this.onLightboxOpen(), 300);
        }
      });
    },

    setupMutationObserver: function() {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (node.classList && node.classList.contains('pswp')) {
              console.log('LuxoticZoomOverlay: PhotoSwipe detected');
              setTimeout(() => this.onLightboxOpen(), 100);
            }
          });
        });
      });

      observer.observe(document.body, { childList: true, subtree: true });
    },

    onLightboxOpen: function() {
      const pswpElement = document.querySelector('.pswp');
      if (!pswpElement) return;

      if (pswpElement.querySelector('.luxotic-zoom-controls')) {
        console.log('LuxoticZoomOverlay: Already initialized');
        this.applyZoomToCurrentImage();
        return;
      }

      console.log('LuxoticZoomOverlay: Setting up custom UI');

      this.pswpElement = pswpElement;
      this.findPswpInstance();
      this.createZoomSlider(pswpElement);
      this.createThumbnails(pswpElement);
      this.createCloseButton(pswpElement);
      this.applyZoomToCurrentImage();
    },

    applyZoomToCurrentImage: function() {
      setTimeout(() => {
        const img = this.getCurrentImageElement();
        if (img) {
          const minZoom = 0.5;   // 最小 50%
          const maxZoom = 1.5;   // 最大 150%
          const initialZoom = 1; // 初始显示原图大小 (100%)

          this.currentZoom = initialZoom;

          if (this.pswpInstance) {
            this.pswpInstance.zoomTo(initialZoom, { x: 0.5, y: 0.5 }, 0);
            // 确保图片居中显示
            setTimeout(() => {
              this.pswpInstance?.panTo(0.5, 0.5);
            }, 50);
          } else {
            img.style.transform = `scale(${initialZoom})`;
            img.style.transformOrigin = 'center center';
          }

          const slider = this.zoomControls?.querySelector('.zoom-slider');
          if (slider) {
            slider.min = minZoom;
            slider.max = maxZoom;
            slider.value = initialZoom;
            slider.step = 0.1;
          }

          console.log('LuxoticZoomOverlay: initial zoom', initialZoom + 'x (centered)');
        }
      }, 200);
    },

    findPswpInstance: function() {
      const productGallery = document.querySelector('product-gallery');
      if (productGallery && productGallery.lightBox && productGallery.lightBox.pswp) {
        this.pswpInstance = productGallery.lightBox.pswp;
        console.log('LuxoticZoomOverlay: Found pswp instance from product-gallery');
        return;
      }

      this.pswpInstance = this.pswpElement.pswp || null;
      if (this.pswpInstance) {
        console.log('LuxoticZoomOverlay: Found pswp instance from element');
        return;
      }

      console.warn('LuxoticZoomOverlay: Could not find pswp instance');
    },

    createZoomSlider: function(pswp) {
      const container = document.createElement('div');
      container.className = 'luxotic-zoom-controls';
      container.innerHTML = `
        <span class="zoom-label zoom-plus">+</span>
        <input type="range" class="zoom-slider" min="0.5" max="1.5" step="0.1" value="1">
        <span class="zoom-label zoom-minus">−</span>
      `;

      pswp.appendChild(container);
      this.zoomControls = container;
      this.setupZoomEvents(container);
      this.applyInitialZoom();
      console.log('LuxoticZoomOverlay: Zoom slider created');
    },

    applyInitialZoom: function() {
      setTimeout(() => {
        const slider = this.zoomControls?.querySelector('.zoom-slider');
        if (slider) {
          slider.value = this.currentZoom;
          this.doUpdateZoom(this.currentZoom);
        }
      }, 150);
    },

    createThumbnails: function(pswp) {
      const container = document.createElement('div');
      container.className = 'luxotic-thumbnail-nav';
      container.innerHTML = this.generateThumbnailsHTML();
      pswp.appendChild(container);
      this.thumbnailContainer = container;
      this.setupThumbnailEvents(container);
      console.log('LuxoticZoomOverlay: Thumbnails created');
    },

    createCloseButton: function(pswp) {
      const container = document.createElement('div');
      container.className = 'luxotic-close-button-container';
      container.innerHTML = `
        <button class="close-btn" aria-label="Close">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M18 6L6 18M6 6l12 12" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      `;
      pswp.appendChild(container);

      container.querySelector('.close-btn').addEventListener('click', () => {
        this.close();
      });

      const existingCloseBtn = document.querySelector('.pswp__button--close');
      if (existingCloseBtn) {
        existingCloseBtn.style.display = 'none';
      }

      console.log('LuxoticZoomOverlay: Close button created');
    },

    close: function() {
      if (this.pswpInstance) {
        this.pswpInstance.close();
      } else if (this.pswpElement && this.pswpElement.pswp) {
        this.pswpElement.pswp.close();
      } else {
        const productGallery = document.querySelector('product-gallery');
        if (productGallery && productGallery.lightBox) {
          productGallery.lightBox.close();
        }
      }
    },

    generateThumbnailsHTML: function() {
      const dataSource = this.getDataSource();
      let html = '';

      dataSource.forEach((item, index) => {
        let thumbSrc = item.msrc || item.src || '';
        thumbSrc = this.getOptimizedThumbnailUrl(thumbSrc);
        const isActive = index === this.currentIndex ? 'active' : '';
        html += `
          <div class="thumbnail-item ${isActive}" data-index="${index}" aria-label="View image ${index + 1}">
            <img src="${thumbSrc}" alt="Thumbnail ${index + 1}" loading="lazy" decoding="async">
          </div>
        `;
      });

      return html;
    },

    getOptimizedThumbnailUrl: function(url) {
      if (!url) return '';

      if (url.includes('cdn.shopify.com')) {
        if (url.includes('?')) {
          return url + '&width=120&height=120&crop=center';
        } else {
          return url + '?width=120&height=120&crop=center';
        }
      }
      return url;
    },

    getDataSource: function() {
      if (this.pswpInstance && this.pswpInstance.options && this.pswpInstance.options.dataSource) {
        return this.pswpInstance.options.dataSource;
      }

      const productGallery = document.querySelector('product-gallery');
      if (productGallery && productGallery.lightBox && productGallery.lightBox.pswp) {
        const pswp = productGallery.lightBox.pswp;
        if (pswp.options && pswp.options.dataSource) {
          return pswp.options.dataSource;
        }
      }

      return [];
    },

    getCurrentSlideElement: function() {
      const items = document.querySelectorAll('.pswp__item');
      for (let i = 0; i < items.length; i++) {
        if (items[i].getAttribute('aria-hidden') === 'false') {
          return items[i];
        }
      }
      return items[0] || null;
    },

    getCurrentImageElement: function() {
      const slide = this.getCurrentSlideElement();
      return slide?.querySelector('.pswp__img') || null;
    },

    doUpdateZoom: function(newZoom) {
      newZoom = Math.max(this.minZoom, Math.min(this.maxZoom, newZoom));
      this.currentZoom = newZoom;

      const slider = this.zoomControls?.querySelector('.zoom-slider');
      if (slider) {
        slider.value = newZoom;
      }

      if (this.pswpInstance) {
        this.pswpInstance.zoomTo(newZoom, { x: 0.5, y: 0.5 }, 0);
        console.log('LuxoticZoomOverlay: Applied zoom via PSWP API', newZoom);
      } else {
        const img = this.getCurrentImageElement();
        if (img) {
          img.style.transform = `scale(${newZoom})`;
          img.style.transformOrigin = 'center center';
          console.log('LuxoticZoomOverlay: Applied zoom via CSS', newZoom);
        }
      }
    },

    setupZoomEvents: function(container) {
      const slider = container.querySelector('.zoom-slider');
      const zoomPlus = container.querySelector('.zoom-plus');
      const zoomMinus = container.querySelector('.zoom-minus');

      if (!slider) return;

      slider.addEventListener('input', () => {
        this.doUpdateZoom(parseFloat(slider.value));
      });

      slider.addEventListener('change', () => {
        this.doUpdateZoom(parseFloat(slider.value));
      });

      zoomPlus.addEventListener('click', () => {
        this.doUpdateZoom(this.currentZoom + 0.1);
      });

      zoomMinus.addEventListener('click', () => {
        this.doUpdateZoom(this.currentZoom - 0.1);
      });
    },

    setupThumbnailEvents: function(container) {
      const thumbnails = container.querySelectorAll('.thumbnail-item');
      thumbnails.forEach((thumb, index) => {
        thumb.addEventListener('click', () => {
          this.goToSlide(index);
          this.updateActiveThumbnail(container, index);
          setTimeout(() => {
            this.applyZoomToCurrentImage();  // 切换时重置到 1x（原图大小）
          }, 200);
        });
      });
    },

    goToSlide: function(index) {
      if (this.pswpInstance) {
        this.pswpInstance.goTo(index);
        this.currentIndex = index;
        console.log('LuxoticZoomOverlay: Going to slide', index);
      } else {
        console.warn('LuxoticZoomOverlay: No pswp instance available');
      }
    },

    updateActiveThumbnail: function(container, index) {
      if (!container) return;

      const thumbnails = container.querySelectorAll('.thumbnail-item');
      thumbnails.forEach((thumb, i) => {
        if (i === index) {
          thumb.classList.add('active');
        } else {
          thumb.classList.remove('active');
        }
      });
    },

    resetZoom: function() {
      this.applyZoomToCurrentImage();
    }
  };

  if (typeof window !== 'undefined') {
    window.LuxoticZoomOverlay = LuxoticZoomOverlay;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => LuxoticZoomOverlay.init());
  } else {
    LuxoticZoomOverlay.init();
  }

})();
